var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkspaceTemporalImageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 35H11.552c-1.01 0-1.514 0-1.748-.2a.833.833 0 01-.29-.699c.025-.306.382-.663 1.096-1.377L24.78 18.552c.66-.66.99-.99 1.37-1.113a1.666 1.666 0 011.03 0c.381.123.711.453 1.371 1.113L35 25v2m-8 8c2.8 0 4.2 0 5.27-.545a5 5 0 002.185-2.185C35 31.2 35 29.8 35 27m-8 8H13c-2.8 0-4.2 0-5.27-.545a5 5 0 01-2.185-2.185C5 31.2 5 29.8 5 27V13c0-2.8 0-4.2.545-5.27A5 5 0 017.73 5.545C8.8 5 10.2 5 13 5h14c2.8 0 4.2 0 5.27.545a5 5 0 012.185 2.185C35 8.8 35 10.2 35 13v14M17.5 14.167a3.333 3.333 0 11-6.667 0 3.333 3.333 0 016.667 0z",
    stroke: "#D2D6DB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgWorkspaceTemporalImageIcon;